import { Component, Input } from '@angular/core';

import { HeaderComponent } from '@coreui/angular-pro';
import {AuthService} from "@auth0/auth0-angular";

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
  standalone: false,

})
export class DefaultHeaderComponent extends HeaderComponent {

  constructor(public auth: AuthService) {
    super();
  }

  @Input() sidebarId: string = 'sidebar1';

  logout() {
    this.auth.logout({logoutParams: {returnTo: document.location.origin}})
  }
}
